import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Naming It: “Romantic Loneliness”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t argue with it. I name it — and stop blaming myself."
    ],
      [
      "Daily intention: Today I don’t argue with it. I name it — and stop blaming myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “Loneliness is a feeling. It is not proof that something is wrong with me.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “Loneliness is a feeling. It is not proof that something is wrong with me.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. When do I feel romantic loneliness most strongly? (moment/time/place)\n[Write here]",
      "2. What is the thing I miss the most inside this feeling? (touch/belonging/someone choosing me/warmth/intimate conversation)\n[Write here]",
      "3. How does loneliness feel in my body? (chest/belly/throat/fatigue)\n[Write here]"
    ],
      [
      "1. When do I feel romantic loneliness most strongly? (moment/time/place)\n[Write here]",
      "2. What is the thing I miss the most inside this feeling? (touch/belonging/someone choosing me/warmth/intimate conversation)\n[Write here]",
      "3. How does loneliness feel in my body? (chest/belly/throat/fatigue)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Today I took a real step: I named the experience without fighting it."
    ],
      [
      "Closing",
      "Today I took a real step: I named the experience without fighting it."
    ]
    ),
    action: localizedGenderNode(
      "When loneliness rises — one breath + the sentence: “This is a feeling. I stay with myself.”",
      "When loneliness rises — one breath + the sentence: “This is a feeling. I stay with myself.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Separating Loneliness from “I’m Not Worthy”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate feeling from conclusion."
    ],
      [
      "Daily intention: Today I separate feeling from conclusion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “The feeling is strong — but it is not a judge.”"
    ],
      [
      "I pause with myself.",
      "One breath. “The feeling is strong — but it is not a judge.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What automatic sentence appears when I feel lonely? (“No one will want me”, “I’m behind”)\n[Write here]",
      "2. What is the bare fact? (no interpretation — two lines)\n[Write here]",
      "3. What gentle truth can I choose today instead of the automatic sentence?\n[Write here]"
    ],
      [
      "1. What automatic sentence appears when I feel lonely? (“No one will want me”, “I’m behind”)\n[Write here]",
      "2. What is the bare fact? (no interpretation — two lines)\n[Write here]",
      "3. What gentle truth can I choose today instead of the automatic sentence?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t have to turn loneliness into an accusation."
    ],
      [
      "Closing",
      "I don’t have to turn loneliness into an accusation."
    ]
    ),
    action: localizedGenderNode(
      "Once today: “This is a story. I return to the facts.” + one breath.",
      "Once today: “This is a story. I return to the facts.” + one breath."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Urge to Fill the Void Quickly (Pause Before Action)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I build a pause before fear-driven action."
    ],
      [
      "Daily intention: Today I build a pause before fear-driven action."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I don’t have to fill the void immediately.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I don’t have to fill the void immediately.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What is my impulsive action when I feel lonely? (scrolling, texting, wrong date, food, alcohol)\n[Write here]",
      "2. What am I really trying to soothe through it? (fear, silence, validation, lack of worth)\n[Write here]",
      "3. What is one clean alternative that respects me today?\n[Write here]"
    ],
      [
      "1. What is my impulsive action when I feel lonely? (scrolling, texting, wrong date, food, alcohol)\n[Write here]",
      "2. What am I really trying to soothe through it? (fear, silence, validation, lack of worth)\n[Write here]",
      "3. What is one clean alternative that respects me today?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I can calm my heart without hurting myself."
    ],
      [
      "Closing",
      "I can calm my heart without hurting myself."
    ]
    ),
    action: localizedGenderNode(
      "Before impulsive action: “30-second pause” — one breath + “I choose myself first.”",
      "Before impulsive action: “30-second pause” — one breath + “I choose myself first.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "What Loneliness Is Asking of Me",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I listen to the request beneath loneliness."
    ],
      [
      "Daily intention: Today I listen to the request beneath loneliness."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Loneliness is a need asking to be heard.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Loneliness is a need asking to be heard.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. If loneliness could speak — what would it ask for?\n[Write here]",
      "2. Which need is strongest for me right now? (warmth/belonging/recognition/touch/gaze)\n[Write here]",
      "3. How can I give myself 10% of this need today without waiting for another person?\n[Write here]"
    ],
      [
      "1. If loneliness could speak — what would it ask for?\n[Write here]",
      "2. Which need is strongest for me right now? (warmth/belonging/recognition/touch/gaze)\n[Write here]",
      "3. How can I give myself 10% of this need today without waiting for another person?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I begin to give myself something — even if small."
    ],
      [
      "Closing",
      "I begin to give myself something — even if small."
    ]
    ),
    action: localizedGenderNode(
      "One small act of self-warmth (shower/blanket/music/walk/regular meal).",
      "One small act of self-warmth (shower/blanket/music/walk/regular meal)."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Shame (“What’s Wrong with Me?”)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I touch shame without letting it define me."
    ],
      [
      "Daily intention: Today I touch shame without letting it define me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Shame wants me to hide. Today I stay present.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Shame wants me to hide. Today I stay present.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What is the most shaming sentence that appears?\n[Write here]",
      "2. If a loved friend said this about themselves — what would I tell them?\n[Write here]",
      "3. What one gentle sentence am I willing to say to myself today instead of shame?\n[Write here]"
    ],
      [
      "1. What is the most shaming sentence that appears?\n[Write here]",
      "2. If a loved friend said this about themselves — what would I tell them?\n[Write here]",
      "3. What one gentle sentence am I willing to say to myself today instead of shame?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Shame does not tell the truth. It says that I’m hurting."
    ],
      [
      "Closing",
      "Shame does not tell the truth. It says that I’m hurting."
    ]
    ),
    action: localizedGenderNode(
      "Hand on chest/belly (if comfortable) + one gentle sentence. Once.",
      "Hand on chest/belly (if comfortable) + one gentle sentence. Once."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Longing for Intimacy (Not Only Partnership)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I recognize that I long for intimacy, not necessarily “someone”."
    ],
      [
      "Daily intention: Today I recognize that I long for intimacy, not necessarily “someone”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Intimacy is closeness. It has many forms.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Intimacy is closeness. It has many forms.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What do I truly long for? (deep conversation/touch/hug/being known)\n[Write here]",
      "2. Where in my life is there already a drop of intimacy? (friend/children/family/work/spirit)\n[Write here]",
      "3. How do I create one small moment of clean intimacy today?\n[Write here]"
    ],
      [
      "1. What do I truly long for? (deep conversation/touch/hug/being known)\n[Write here]",
      "2. Where in my life is there already a drop of intimacy? (friend/children/family/work/spirit)\n[Write here]",
      "3. How do I create one small moment of clean intimacy today?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t wait for perfection. I begin building closeness gradually."
    ],
      [
      "Closing",
      "I don’t wait for perfection. I begin building closeness gradually."
    ]
    ),
    action: localizedGenderNode(
      "One short conversation with a safe person — no explaining, just being.",
      "One short conversation with a safe person — no explaining, just being."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Clean Exposure (Gentle ACT): Being Alone for One Minute",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I practice staying with loneliness for a moment — without escaping."
    ],
      [
      "Daily intention: Today I practice staying with loneliness for a moment — without escaping."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I can be with this for one minute.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I can be with this for one minute.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. When is it hardest for me to be alone?\n[Write here]",
      "2. One-minute practice: I sit with the feeling for one minute, without a screen. What happened in my body?\n[Write here]",
      "3. What did I learn about the wave? (Does it really not pass?)\n[Write here]"
    ],
      [
      "1. When is it hardest for me to be alone?\n[Write here]",
      "2. One-minute practice: I sit with the feeling for one minute, without a screen. What happened in my body?\n[Write here]",
      "3. What did I learn about the wave? (Does it really not pass?)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I grow stronger not because the feeling vanished — but because I stayed."
    ],
      [
      "Closing",
      "I grow stronger not because the feeling vanished — but because I stayed."
    ]
    ),
    action: localizedGenderNode(
      "One minute only. Consistency > force.",
      "One minute only. Consistency > force."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Boundaries with Myself (Not Running into the Wrong Connection)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I protect my heart from “quick fixes”."
    ],
      [
      "Daily intention: Today I protect my heart from “quick fixes”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “The wrong relationship does not solve loneliness — it adds pain.”"
    ],
      [
      "I pause with myself.",
      "One breath. “The wrong relationship does not solve loneliness — it adds pain.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What “quick fix” do I tend to choose when I’m lonely?\n[Write here]",
      "2. What price do I pay when I choose it?\n[Write here]",
      "3. What one small boundary will I set this week to protect myself?\n[Write here]"
    ],
      [
      "1. What “quick fix” do I tend to choose when I’m lonely?\n[Write here]",
      "2. What price do I pay when I choose it?\n[Write here]",
      "3. What one small boundary will I set this week to protect myself?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A boundary is self-love in action."
    ],
      [
      "Closing",
      "A boundary is self-love in action."
    ]
    ),
    action: localizedGenderNode(
      "I remove one trigger that leads to unclean action (app/chat/place).",
      "I remove one trigger that leads to unclean action (app/chat/place)."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "“Everyone Is Coupled and I’m Alone” (Breaking the Myth)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stop reading others’ lives from a single image."
    ],
      [
      "Daily intention: Today I stop reading others’ lives from a single image."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I don’t know their whole story.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I don’t know their whole story.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What comparison sentence appears?\n[Write here]",
      "2. What do I actually know — and what am I only guessing?\n[Write here]",
      "3. What one truth about my path do I choose to remember today?\n[Write here]"
    ],
      [
      "1. What comparison sentence appears?\n[Write here]",
      "2. What do I actually know — and what am I only guessing?\n[Write here]",
      "3. What one truth about my path do I choose to remember today?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "My pace does not mean I’m less. It means I’m on my path."
    ],
      [
      "Closing",
      "My pace does not mean I’m less. It means I’m on my path."
    ]
    ),
    action: localizedGenderNode(
      "Once today — I stop comparison: close screen / breathe / return to myself.",
      "Once today — I stop comparison: close screen / breathe / return to myself."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Building a Routine That Holds Me",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I give myself an anchor — so my heart has ground."
    ],
      [
      "Daily intention: Today I give myself an anchor — so my heart has ground."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I build stability in small steps.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I build stability in small steps.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. At what times of day does loneliness attack most?\n[Write here]",
      "2. What one simple anchor could fit there? (walk/meal/shower/music/order)\n[Write here]",
      "3. What do I commit to doing for 10 minutes only today?\n[Write here]"
    ],
      [
      "1. At what times of day does loneliness attack most?\n[Write here]",
      "2. What one simple anchor could fit there? (walk/meal/shower/music/order)\n[Write here]",
      "3. What do I commit to doing for 10 minutes only today?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A small routine is a steady hug."
    ],
      [
      "Closing",
      "A small routine is a steady hug."
    ]
    ),
    action: localizedGenderNode(
      "I do the 10 minutes — and add nothing more.",
      "I do the 10 minutes — and add nothing more."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Practicing Being Seen Without Partnership",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I restore visibility and belonging — in a clean way."
    ],
      [
      "Daily intention: Today I restore visibility and belonging — in a clean way."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Even without partnership — I deserve to be seen.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Even without partnership — I deserve to be seen.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Where in my life do I feel unseen?\n[Write here]",
      "2. What is one healthy way to be in connection today? (conversation/group/family/friend/community)\n[Write here]",
      "3. What scares me about asking for connection?\n[Write here]"
    ],
      [
      "1. Where in my life do I feel unseen?\n[Write here]",
      "2. What is one healthy way to be in connection today? (conversation/group/family/friend/community)\n[Write here]",
      "3. What scares me about asking for connection?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Asking for connection is courage, not weakness."
    ],
      [
      "Closing",
      "Asking for connection is courage, not weakness."
    ]
    ),
    action: localizedGenderNode(
      "I send one clean message to a safe person: “I’d like to hear you.”",
      "I send one clean message to a safe person: “I’d like to hear you.”"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Nighttime Loops (Loneliness in Quiet Hours)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I give my mind an “end of day” so it can rest."
    ],
      [
      "Daily intention: Today I give my mind an “end of day” so it can rest."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Tonight I don’t have to solve.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Tonight I don’t have to solve.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What is my nighttime loop around loneliness?\n[Write here]",
      "2. What is the loop trying to get for me? (control/hope/validation)\n[Write here]",
      "3. What closing sentence for the night do I choose?\n[Write here]",
      "4. What 3-minute ritual will help before sleep?\n[Write here]"
    ],
      [
      "1. What is my nighttime loop around loneliness?\n[Write here]",
      "2. What is the loop trying to get for me? (control/hope/validation)\n[Write here]",
      "3. What closing sentence for the night do I choose?\n[Write here]",
      "4. What 3-minute ritual will help before sleep?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A tired mind tells powerful stories. Tonight I choose rest."
    ],
      [
      "Closing",
      "A tired mind tells powerful stories. Tonight I choose rest."
    ]
    ),
    action: localizedGenderNode(
      "Before sleep: my closing sentence + one breath. That’s it.",
      "Before sleep: my closing sentence + one breath. That’s it."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Turning Loneliness into Direction (What I’m Building)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today loneliness becomes a compass: what truly matters to me."
    ],
      [
      "Daily intention: Today loneliness becomes a compass: what truly matters to me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “What I lack teaches me what I want to build.”"
    ],
      [
      "I pause with myself.",
      "One breath. “What I lack teaches me what I want to build.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What do I want most in my life? (relationship/home/belonging/closeness/partnership)\n[Write here]",
      "2. Which one value will lead me from now on? (respect/truth/peace/stability/gentleness)\n[Write here]",
      "3. What small habit moves me closer to this value this week?\n[Write here]",
      "4. What do I promise myself on a hard day? (one sentence)\n[Write here]"
    ],
      [
      "1. What do I want most in my life? (relationship/home/belonging/closeness/partnership)\n[Write here]",
      "2. Which one value will lead me from now on? (respect/truth/peace/stability/gentleness)\n[Write here]",
      "3. What small habit moves me closer to this value this week?\n[Write here]",
      "4. What do I promise myself on a hard day? (one sentence)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t have to stay in pain. I can build a life."
    ],
      [
      "Closing",
      "I don’t have to stay in pain. I can build a life."
    ]
    ),
    action: localizedGenderNode(
      "I plan one small thing for the coming week that brings me a future (meeting/group/project).",
      "I plan one small thing for the coming week that brings me a future (meeting/group/project)."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Release and Closure (Staying with Myself)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I close a chapter without erasing it. I return myself to myself."
    ],
      [
      "Daily intention: Today I close a chapter without erasing it. I return myself to myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I release without disappearing.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I release without disappearing.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Three things I stop doing when I feel lonely (because they hurt me):\n[Write here]",
      "2. Three things I start doing to build warmth and belonging:\n[Write here]",
      "3. A return sentence for hard days (short, clear, in my pocket):\n[Write here]"
    ],
      [
      "1. Three things I stop doing when I feel lonely (because they hurt me):\n[Write here]",
      "2. Three things I start doing to build warmth and belonging:\n[Write here]",
      "3. A return sentence for hard days (short, clear, in my pocket):\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "I do not erase loneliness —",
      "I stop letting it define me.",
      "I continue walking —",
      "slowly, quietly, with myself.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "I do not erase loneliness —",
      "I stop letting it define me.",
      "I continue walking —",
      "slowly, quietly, with myself.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "One action that marks a “new chapter”: walk in a new place / weekly planning / one brave conversation.",
      "One action that marks a “new chapter”: walk in a new place / weekly planning / one brave conversation."
    ),
  },
].map(buildNormalizedDay);

export const romanticLonelinessBlueprintEn = buildNormalizedPilotBlueprint({
  id: "romantic_loneliness_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "romantic_loneliness",
  category: "general",
  journeyName: {
    he: "בדידות רומנטית",
    en: "Romantic Loneliness",
    es: "Soledad Romántica",
  },
  days,
});

export default romanticLonelinessBlueprintEn;
